import React from 'react'
import '../../../css/public/pages/home.css'
import Hero from './hero'
import Samples from './samples'
import Livetracking from './livetracking'
import Services from './services'
import Facts from './facts'
import Testimonials from './testimonials'
import WhatweSupport from './whatwesupport'
import Labs from './labs'
import Reveal from '../../../components/reveal'

const Index = () => {
  return (
    <div>
      <Hero/>
      <Reveal><Livetracking/></Reveal>
      <Reveal><Samples/></Reveal>
      <Reveal><Services/></Reveal>
      <Reveal><Facts/></Reveal>
      <Reveal><Testimonials /></Reveal>
      <Reveal><WhatweSupport/></Reveal>
      <Reveal><Labs/></Reveal>
    </div>
  )
}

export default Index
